export const getLuma = (color: string) => {
  let hex = color.replace(/^\s*#|\s*$/g, "");

  if (hex.length === 3) {
    hex = hex.replace(/(.)/g, "$1$1");
  }

  const R = parseInt(hex.substr(0, 2), 16);
  const G = parseInt(hex.substr(2, 2), 16);
  const B = parseInt(hex.substr(4, 2), 16);

  return R * 0.2126 + G * 0.7152 + B * 0.0722;
};

export const hexColorToRGBA = (color: string, alpha: number) => {
  let hex = color.replace(/^\s*#|\s*$/g, "");

  if (hex.length === 3) {
    hex = hex.replace(/(.)/g, "$1$1");
  }

  const R = parseInt(hex.substr(0, 2), 16);
  const G = parseInt(hex.substr(2, 2), 16);
  const B = parseInt(hex.substr(4, 2), 16);

  return `rgba(${R}, ${G}, ${B}, ${alpha})`;
};
